<script setup lang="ts">
import ClientCard from "@/components/ClientCard.vue";
import type { ClientDto } from "@/types/protocol";

defineProps<{ clients: readonly ClientDto[] }>();
</script>

<template>
  <section>
    <h2>Verbundene PCs ({{ clients.length }})</h2>
    <div v-if="clients.length" class="grid">
      <ClientCard v-for="client in clients" :key="client.machine" :client="client" />
    </div>
    <div v-else class="empty">Kein PC verbunden.</div>
  </section>
</template>

<style scoped>
.grid {
  display: grid;
  gap: 14px;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
}
</style>
